if (document.getElementById('page-mypageEntry')) {
  page()
}

function page() {
  // プルダウンの絞り込み
  window.addEventListener('input', function (e) {
    const item = e.target.closest('#js-userSearch')
    if (!item) {
      return
    }
    const inputText = item.value
    let hitCount = 0
    const optionList = document.querySelectorAll('#js-userSearch-select option')
    const optionFirst = document.querySelector('#js-userSearch-select option')
    for (const option of optionList) {
      const optionText = option.dataset.text

      if (~optionText.indexOf(inputText)) {
        option.style.display = ''
        ++hitCount
      } else {
        option.style.display = 'none'
      }
    }

    if (hitCount === 0) {
      optionFirst.innerText = '該当者なし'
    } else {
      optionFirst.innerText = '該当者 ' + hitCount + '名'
      if (inputText === '') {
        optionFirst.innerText = '受講者の履歴を表示'
      }
    }
  })
}
